import EducationService from "@/lib/Education";
import { useEducationStore } from "@/lib/Education/store";
import { useQuery } from "@tanstack/react-query";
import useCurrentUser from "./useCurrentUser";
import { useEffect } from "react";

export default function useEducationStats() {
  const { data: user } = useCurrentUser();
  const { setUser, user: userStats } = useEducationStore();
  const { data: userData, isLoading } = useQuery({
    queryKey: ['education-stats'],
    queryFn: () => EducationService.getUser(user?.account?.id),
    enabled: !!user,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false
  })
  useEffect(() => {
    if (userData) setUser(userData);
  }, [userData])

  return {
    stats: userStats,
    isLoading,
  };
}